import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';
// The report face, at the weights the render worker embeds in the PDF, so the preview wraps and
// paginates the same way the PDF does (a fallback face is wider and pushes cards into the footer).
import '@fontsource/roboto/latin-400.css';
import '@fontsource/roboto/latin-500.css';
import '@fontsource/roboto/latin-700.css';
import '@fontsource/roboto/latin-800.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode><App /></StrictMode>
);
